import { inject, Pipe, PipeTransform } from '@angular/core';
import { HighlightService, Position } from './highlight.service';


@Pipe({
    name: 'search',
})
export class SearchFilterPipe implements PipeTransform {

    private hs = inject(HighlightService);

    transform<T extends Record<string, any>>(items: T[], field: keyof T, text: string, withScore = false): T[] {
        if (!text || !items) {
            return items;
        }

        const matched: Array<[Position[], T]> = [];
        for (const item of items) {
            const search = this.hs.fuzzySearch(text, item[field]);
            if (search.length > 0) {
                matched.push([search, item]);
            }
        }

        if (withScore) {
            const score = (x: [Position[], T]) => {
                const [search, item] = x;
                if (item[field].lenght === 0) {
                    return 0;
                }

                let sum = 0;
                for (const position of search) {
                    const [start, end] = position;
                    sum += end - start;
                }
                return sum / item[field].length;
            };

            matched.sort((a, b) => {
                if (score(a) > score(b)) {
                    return -1;
                } else if (score(a) < score(b)) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        return matched.map(([_, item]) => item);
    }
}
